import React, { useId } from 'react';

interface CyberCharacterProps {
    variant?: 'welcome';
}

export const CyberCharacter = (props: CyberCharacterProps) => {
    const { variant = 'welcome' } = props;
    const rawId = useId().replace(/[^a-zA-Z0-9]/g, '');
    const skinId = `mcsa-skin-${rawId}`;
    const shirtId = `mcsa-shirt-${rawId}`;
    const hairId = `mcsa-hair-${rawId}`;
    const cheekId = `mcsa-cheek-${rawId}`;

    return (
        <div className={`mcsa_cyber_character mcsa_cyber_character--${variant}`}>
            <div className='mcsa_cyber_character__stage' aria-hidden='true'>
                <span className='mcsa_cyber_character__scan_line' />
                <span className='mcsa_cyber_character__scan_mark mcsa_cyber_character__scan_mark--one' />
                <span className='mcsa_cyber_character__scan_mark mcsa_cyber_character__scan_mark--two' />
                <span className='mcsa_cyber_character__scan_mark mcsa_cyber_character__scan_mark--three' />
                <svg className='mcsa_cyber_character__svg' viewBox='0 0 240 280' role='img' aria-hidden='true'>
                    <defs>
                        <linearGradient id={skinId} x1='0' y1='0' x2='0' y2='1'>
                            <stop offset='0%' stopColor='#F8D7C4' />
                            <stop offset='100%' stopColor='#E8B89A' />
                        </linearGradient>
                        <linearGradient id={shirtId} x1='0' y1='0' x2='1' y2='1'>
                            <stop offset='0%' stopColor='#5B3B82' />
                            <stop offset='100%' stopColor='#4A306D' />
                        </linearGradient>
                        <linearGradient id={hairId} x1='0' y1='0' x2='0' y2='1'>
                            <stop offset='0%' stopColor='#2F2438' />
                            <stop offset='100%' stopColor='#1C1524' />
                        </linearGradient>
                        <radialGradient id={cheekId} cx='50%' cy='50%' r='50%'>
                            <stop offset='0%' stopColor='#F3A6A0' stopOpacity='0.55' />
                            <stop offset='100%' stopColor='#F3A6A0' stopOpacity='0' />
                        </radialGradient>
                    </defs>
                    <ellipse cx='120' cy='258' rx='46' ry='10' fill='#4A306D' opacity='0.08' />
                    <path d='M78 168c8 38 18 62 42 62s34-24 42-62c-12 8-26 12-42 12s-30-4-42-12z' fill='#343B4A' />
                    <path
                        d='M70 128c6-6 18-12 50-12s44 6 50 12c4 18-2 46-18 58-10 8-26 14-32 14s-22-6-32-14c-16-12-22-40-18-58z'
                        fill={`url(#${shirtId})`}
                    />
                    <path d='M86 146c8 22 16 34 34 34s26-12 34-34c-10 6-22 10-34 10s-24-4-34-10z' fill='#3D265A' opacity='0.35' />
                    <rect x='64' y='132' width='18' height='46' rx='9' fill={`url(#${skinId})`} />
                    <rect x='158' y='132' width='18' height='46' rx='9' fill={`url(#${skinId})`} />
                    <circle cx='120' cy='96' r='46' fill={`url(#${skinId})`} />
                    <path
                        d='M78 92c4-28 22-46 42-48 22-2 40 12 46 36 2 10-4 16-12 12-10-6-22-16-36-16s-24 8-34 16c-6 4-8-2-6-12z'
                        fill={`url(#${hairId})`}
                    />
                    <ellipse cx='102' cy='104' rx='5.5' ry='6.5' fill='#2A2233' />
                    <ellipse cx='138' cy='104' rx='5.5' ry='6.5' fill='#2A2233' />
                    <circle cx='104' cy='102' r='1.6' fill='#fff' />
                    <circle cx='140' cy='102' r='1.6' fill='#fff' />
                    <ellipse cx='96' cy='114' rx='8' ry='5' fill={`url(#${cheekId})`} />
                    <ellipse cx='144' cy='114' rx='8' ry='5' fill={`url(#${cheekId})`} />
                    <path d='M110 122c6 7 14 7 20 0' fill='none' stroke='#C47A6A' strokeWidth='2.4' strokeLinecap='round' />
                    <path
                        d='M108 168c4 14 8 28 12 28h0c4 0 8-14 12-28'
                        fill='none'
                        stroke='#B284FF'
                        strokeWidth='3'
                        strokeLinecap='round'
                        opacity='0.55'
                    />
                </svg>
            </div>
            <p className='mcsa_cyber_character__sr_only'>
                MindShield character being scanned, representing your cyber-resilience profile.
            </p>
        </div>
    );
};
